import { createRoute, Outlet } from "@tanstack/react-router";
import { appLayoutRoute } from "@/routes/layout-routes";
import { OrganisationListScreen } from "@/app/Organisations/Screens/OrganisationListScreen";
import { OrganisationRecordScreen } from "@/app/Organisations/Screens/OrganisationRecordScreen";
import { OrganisationDetailsScreen } from "@/app/Organisations/Screens/OrganisationDetailsScreen";
import { OrganisationMembersScreen } from "@/app/Organisations/Screens/OrganisationMembersScreen";
import { OrganisationSuppliersScreen } from "@/app/Organisations/Screens/OrganisationSuppliersScreen";
import { OrganisationInvoicesScreen } from "@/app/Organisations/Screens/OrganisationInvoicesScreen";
import { OrganisationActivityScreen } from "@/app/Organisations/Screens/OrganisationActivityScreen";
import { fetchQuery } from "@/lib/GraphQLCodegen/fetcher";
import { organisationRecordQuery } from "@/app/Organisations/GraphQL/organisationRecordQuery";

export const organisationsLayoutRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/organisations",
  component: Outlet,
});

export const organisationListRoute = createRoute({
  getParentRoute: () => organisationsLayoutRoute,
  path: "/",
  component: OrganisationListScreen,
  head: () => ({
    meta: [
      {
        title: "Organisations - Imoova Admin",
      },
    ],
  }),
});

export const organisationRoute = createRoute({
  getParentRoute: () => organisationsLayoutRoute,
  path: "$id",
  component: OrganisationRecordScreen,
  loader: ({ params }) => {
    return fetchQuery(organisationRecordQuery, { id: params.id }, params.orgId);
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: `${loaderData?.organisation.name ?? "--"} - Imoova Admin`,
      },
    ],
  }),
});

export const organisationDetailRoute = createRoute({
  getParentRoute: () => organisationRoute,
  path: "/",
  component: OrganisationDetailsScreen,
});

export const organisationMembersRoute = createRoute({
  getParentRoute: () => organisationRoute,
  path: "members",
  component: OrganisationMembersScreen,
});

export const organisationSuppliersRoute = createRoute({
  getParentRoute: () => organisationRoute,
  path: "suppliers",
  component: OrganisationSuppliersScreen,
});

export const organisationInvoicesRoute = createRoute({
  getParentRoute: () => organisationRoute,
  path: "invoices",
  component: OrganisationInvoicesScreen,
});

export const organisationActivityRoute = createRoute({
  getParentRoute: () => organisationRoute,
  path: "activity",
  component: OrganisationActivityScreen,
});
